import {
    AttachEventsModalInterface
} from "@/views/Admin/Events/Event/Promocodes/AttachEventsModal/AttachEventsModal.interface";

export const AttachEventsModalSchema: AttachEventsModalInterface = {
    search: {
        value: '',
        isActive: false,
    },
    baseEvents: null,
    selectedEvents: {},
    meta: {
        currentPage: 1,
        from: 0,
        lastPage: 0,
        perPage: 10,
        to: 0,
        total: 0,
        sizes: {10: '10', 20: '20', 50: '50', 100: '100'}
    },
}
